import Link from '@/components/Link/Link';
import { getLoginUrlByEnv, MYSUNRUN_URL } from '@/constants/baseUrls';
import { Contentful } from '@/contentful/types';
import { Event, trackEvents } from '@/utils/analytics';
import { Environment } from '@/utils/environment';

export interface CTAContent extends Contentful {
  fields: {
    text: string;
    type?: 'Link' | 'Button';
    url: string;
  };
}

export interface FieldlessCTAContent {
  text: string;
  url: string;
  type?: 'Link' | 'Button';
}

interface Props {
  content: FieldlessCTAContent;
  className?: string;
  gaEvent?: Event;
  testId?: string;
}

export default function CTA({
  content,
  className = '',
  gaEvent,
  testId,
}: Props) {
  const { text, type } = content;
  const url =
    content.url === MYSUNRUN_URL[Environment.PROD]
      ? getLoginUrlByEnv()
      : content.url;
  const baseClassNames =
    type === 'Link' ? 'cta-link' : 'cta-button theme-btn theme-btn-small';
  const classNames = className
    ? `${baseClassNames} ${className}`
    : baseClassNames;

  return (
    <Link
      data-testid={testId}
      className={classNames}
      href={url}
      onClick={() => {
        if (gaEvent) {
          trackEvents(gaEvent);
        }
      }}
    >
      {text}
    </Link>
  );
}
